import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "./styles.m.css";
import { Icon } from "../../../../atoms/icon";
import { LoadVuukle, GA } from "../../../../../integrations";
import { isPremium } from "../../../../../data/story";
import { humanizeDate } from "../../../../utils/time-format";
import SocialShareSection from "../../../../atoms/social-share-section";
import assetify from "@quintype/framework/assetify";
import googlenews from "../../../../../../assets/images/Vikatan_google_news_new.svg";
import appinstall from "../../../../../../assets/images/install-app.png";

function CartoonStory(props) {
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const renderTextStoryHeaderCard = get(props, ["renderTextStoryHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const storyIndex = get(props, ["index"], 0);
  const handleExpandStory = get(props, ["handleExpandStory"], () => null);
  const [readMore, setReadMore] = useState(storyIndex !== 0);
  const story = get(props, ["story"], () => null);
  const cards = readMore ? (isPremium(story) ? [] : singleCard.slice(0, 1)) : singleCard;

  const [showRelativeTime, setShowRelativeTime] = React.useState(false);

  const cardLength = cards.length;

  const handleChange = () => {
    const story = get(props, ["story"], () => null);
    LoadVuukle.register(story, props.config.vikatanHosts);
    GA.customEvent("Readmore-storyfeed", " Clicked", "articleloadmore");
    setReadMore(false);
    handleExpandStory();
  };

  useEffect(() => {
    setShowRelativeTime(true);
  }, []);

  const adShow = isPremium(story) ? !readMore : true;

  return (
    <div className="page-content">
      <div className={`container`}>
        <Breadcrumb subSection={section} config={props.config} />
      </div>
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} js-story`}>
            <div>
              <div className="desktop hidden-mobile">
                {renderHeaderCard()}
                <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
              </div>
              <div className="mobile hidden-desktop">
                {renderTextStoryHeaderCard()}
                <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
                {story.authors && story.authors.length ? (
                  <div className={styles.contributors}>
                    <div className={styles.contributorOuter}>
                      <SocialShareSection story={story} config={props.config} />
                    </div>
                    <div className="goog-vikatan-news">
                      <div className="hidden-mobile">
                        <a
                          href="https://news.google.com/publications/CAAqBwgKMJ6N_wow3fz3Ag?hl=ta&amp;gl=IN&amp;ceid=IN%3Ata"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.link}
                        >
                          <img
                            src={assetify(googlenews)}
                            alt=""
                            className={`${styles["google-follow"]} ${styles["appinstall"]}`}
                            width=""
                            height=""
                          />
                        </a>
                      </div>
                      <div className="hidden-desktop">
                        <a
                          href="https://vikatanmobile.page.link/article_header"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.link}
                        >
                          <img
                            src={assetify(appinstall)}
                            alt=""
                            className={styles["appinstall"]}
                            width="135px"
                            height="33px"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className={styles["published-time-wrap"]}>
                  {story["first-published-at"] && (
                    <span className={styles["published"]}>
                      Published:
                      <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                        {humanizeDate(story["first-published-at"], showRelativeTime ? "relative" : "absolute")}
                      </time>
                    </span>
                  )}
                  {story["last-published-at"] && (
                    <span className={styles["updated"]}>
                      Updated:
                      <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                        {humanizeDate(story["last-published-at"], showRelativeTime ? "relative" : "absolute")}
                      </time>
                    </span>
                  )}
                </div>
              </div>

              {cards &&
                cards.map((card, index) => {
                  return (
                    <React.Fragment key={card.id}>
                      <StoryCard
                        card={card}
                        story={props.story}
                        showCard={readMore}
                        index={index}
                        storyIndex={storyIndex}
                        cardLength={cardLength}
                        renderRelatedArticle={renderRelatedArticle}
                      />
                    </React.Fragment>
                  );
                })}
            </div>
            {readMore && (
              <div className={styles["readmore-wrapper"]}>
                <div onClick={() => handleChange()} className={styles["read-more-button"]}>
                  <span>மேலும் படிக்க</span>
                  <div className={styles["arrows"]}>
                    <Icon type={"angle-right"} />
                    <Icon type={"angle-right"} />
                  </div>
                </div>
              </div>
            )}

            {renderFooter(readMore)}
          </article>
        </div>
        {renderSidebar(adShow)}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any,
  metadata: PropTypes.shape({
    "reference-url": PropTypes.string
  })
});
CartoonStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  isAccessible: PropTypes.bool,
  relatedStories: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      story: story
    })
  ),
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  handleExpandStory: PropTypes.func,
  renderTextStoryHeaderCard: PropTypes.func
};

export { CartoonStory };
